
const Device = {
  deviceCode: '',//plus.device.imei;
  deviceType: '',//plus.os.name;
  deviceInfo: '',//plus.device.model;
  deviceChannel: '',
  version: '1.0.1',
  
  init(ctx){
    this.deviceCode = '3154567456789034569'
    this.deviceType = 'Android'
    this.deviceInfo = 'XiaoMi'
    
    if(!window.client.isClient){
      this.deviceCode = ctx.$preference.getBrowserIMEI()
      this.deviceType = 'Android'
      this.deviceInfo = 'Browser'
    }
  }
}

Device.install = function (Vue, options) {
  Vue.prototype.$device = Device
}

export default Device;

//
// this.deviceCode = '864555037615117'
// this.deviceType = 'Android23'
// this.deviceInfo = 'vivo X9'



// WEBPACK FOOTER //
// ./src/plugins/device.js